import { faCreditCard } from '@fortawesome/pro-light-svg-icons';
import { CardCvcElement } from '@stripe/react-stripe-js';
import { StripeCardCvcElementChangeEvent } from '@stripe/stripe-js';
import React from 'react';
import BaseStripeCardInput from './BaseStripeCardInput';
import { getStripeElementStyles } from './stripeStyles';

interface CardCvcInputProps {
  disabled?: boolean;
  error?: string;
  onError?: (error: string | undefined) => void;
  onComplete?: (complete: boolean) => void;
  label?: string;
  withAsterisk?: boolean;
}

const CardCvcInput: React.FC<CardCvcInputProps> = ({
  disabled = false,
  error,
  onError,
  onComplete,
  label = 'Security Code',
  withAsterisk = false,
}) => {
  const handleChange = (event: StripeCardCvcElementChangeEvent) => {
    if (onError) {
      onError(event.error?.message);
    }
    if (onComplete) {
      onComplete(event.complete);
    }
  };

  return (
    <BaseStripeCardInput
      label={label}
      withAsterisk={withAsterisk}
      disabled={disabled}
      error={error}
      icon={faCreditCard}
    >
      <CardCvcElement
        options={{
          placeholder: '000',
          disabled,
          style: getStripeElementStyles(disabled),
        }}
        onChange={handleChange}
      />
    </BaseStripeCardInput>
  );
};

export default CardCvcInput;
